import React from "react";
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png";

function FooterMobile() {
  return (
    <footer className="tp-footer-mobile">
      <img
        src={logo}
        alt="Technoparts"
        className="tp-footer-mobile-logo"
      />
    </footer>
  );
}

export default FooterMobile;